import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { ImageType } from '../types';
import { downloadUserImage } from '../utils/functions';

export interface EmployeeDto {
  id: number,
  imageLink: string,
  isAvailableForToday: boolean,
  lastWithFirstName: string,
  profileAccessType: string,
  requestEndDate: string | null,
  requestStartDate: string | null,
  requestTypeId: string | null,
  requestTypeName: string | null,
  isHoliday: boolean | null,
  holidayName: string | null,
}
export interface GlobalSearchCacheResult {
  employees: EmployeeDto[], employeesSize: number
}
class Search {
  constructor() {
    makeAutoObservable(this);
  }
  images: ImageType[] = [];
  loadedQuery: string | undefined = undefined;
  searchList: GlobalSearchCacheResult = { employees: [], employeesSize: 0 };
  expectedQuery = '';
  recentlySearchList: GlobalSearchCacheResult = { employees: [], employeesSize: 0 };
  search = async (query: string, path?: string) => {
    try {
      this.expectedQuery = query;
      this.loadedQuery = undefined;
      const res = await apiConfig.globalSearchService.search(query, path);
      if (query === this.expectedQuery) {
        this.searchList = res;
        this.loadedQuery = query;
      }
    } catch (e) {
      this.loadedQuery = query;
      this.searchList = { employees: [], employeesSize: 0 };
    }
  };
  fetchPortraitUrl = async () => {
    const uniqArray: string[] = [];
    this.recentlySearchList.employees.forEach((req) => {
      if (!uniqArray.includes(req.imageLink)) {
        uniqArray.push(req.imageLink);
      }
    });
    this.searchList.employees.forEach((req) => {
      if (!uniqArray.includes(req.imageLink)) {
        uniqArray.push(req.imageLink);
      }
    });
    const prepareArray = uniqArray.map(evt => downloadUserImage(evt));
    const imagesResult = Promise.all(prepareArray);
    try {
      const res = await imagesResult;
      this.images = res.map(i => {
        return { originalUrl: i.imgUrl, blob: i.blob };
      });
    }
    catch (e) {
      throw new Error('image loading error');
    }
  };

  refreshSearchList = () => {
    this.searchList = { employees: [], employeesSize: 0 };
  };
  recentlySearch = async () => {
    try {
      const res = await apiConfig.globalSearchService.recentlySearch();
      this.recentlySearchList = res;
    }
    catch (e) {
      this.recentlySearchList = { employees: [], employeesSize: 0 };
    }
  };
  addToRecentlySearch = async (userId: number) => {
    apiConfig.globalSearchService.addToRecentlySearch(userId);
  };

  checkRelations = async (userId: number) => {
    return apiConfig.globalSearchService.checkRelations(userId);
  };
}

export const GlobalSearchStore = new Search();
